import { DOG_BREEDS } from '../../../../utils/constants'
import SmoothCoat from '../../../../assets/grooming/smooth_coat.png'
import CombinationCoat from '../../../../assets/grooming/combination_coat.png'
import DenseCoat from '../../../../assets/grooming/dense_coat.png'
import DoodleCombo from '../../../../assets/grooming/doodle_combo.png'
import DoodleCurly from '../../../../assets/grooming/doodle_curly.png'
import DoodleShaggy from '../../../../assets/grooming/doodle_shaggy.png'
import DoodleWavy from '../../../../assets/grooming/doodle_wavy.png'
import DoodleWire from '../../../../assets/grooming/doodle_wire.png'
import DoodleWool from '../../../../assets/grooming/doodle_wool.png'
import DropCoat from '../../../../assets/grooming/drop_coat.png'
import HeavyCoat from '../../../../assets/grooming/heavy_coat.png'
import LongWireCoat from '../../../../assets/grooming/long_wire_coat.png'
import ShortCoat from '../../../../assets/grooming/short_coat.png'
import ShortWireCoat from '../../../../assets/grooming/short_wire_coat.png'
import SilkyCoat from '../../../../assets/grooming/silky_coat.png'
import WavyCoat from '../../../../assets/grooming/wavy_coat.png'
import CurlyCoat from '../../../../assets/grooming/curly_coat.png'

export const GROOMING_PROFILE_KEYS = {
	breed_mix: 'breed_mix',
	breeds: 'breeds',
	client_grooming_notes: 'client_grooming_notes',
	coat_length: 'coat_length',
	coat_type: 'coat_type',
	ear_cleaning: 'ear_cleaning',
	glands: 'glands',
	shedding: 'shedding',
	shedding_amount: 'shedding_amount',
	shedding_frequency: 'shedding_frequency',
	grooming_level: 'grooming_level',
	nail_trimming: 'nail_trimming',
	shedding: 'shedding',
	weight: 'weight',
	closest_breed_coat: 'closest_breed_coat',
	grooming_addons: 'grooming_addons',
	allowed_grooming_services: 'allowed_grooming_services'
}

export const SHEDDING_AMOUNT_TYPES = {
	none: 'none',
	some: 'some',
	significant: 'significant',
	excessive: 'excessive'
}

export const SHEDDING_AMOUNTS = {
	[SHEDDING_AMOUNT_TYPES.none]: 'None/Minimal',
	[SHEDDING_AMOUNT_TYPES.some]: 'Some',
	[SHEDDING_AMOUNT_TYPES.significant]: 'A Lot',
	[SHEDDING_AMOUNT_TYPES.excessive]: 'Hair Everywhere!'
}

export const SHEDDING_FREQUENCIES = {
	always: 'Consistent shedding year round',
	seasonal: 'Only seasonal shedding',
	seasonish: 'Some year round, but more seasonally'
}

export const BREED_MIX_TYPES = {
	single: 'single',
	single_suspected: 'single_suspected',
	doodle: 'doodle',
	combo: 'combo',
	unknown: 'unknown'
}

export const BREED_MIXES = {
	[BREED_MIX_TYPES.single]: 'Single breed - purebred',
	[BREED_MIX_TYPES.single_suspected]: 'Single breed - suspected',
	[BREED_MIX_TYPES.doodle]: 'Mix of poodle & one other breed',
	[BREED_MIX_TYPES.combo]: 'Mix of 2 known breeds',
	[BREED_MIX_TYPES.unknown]: 'Unknown or mix of 3+ breeds'
}

const COAT_LENGTH = {
	short: 'Short',
	medium: 'Medium',
	long: 'Long',
	variable: 'Variable'
}

export const GROOMING_LEVELS = {
	trim: 'Trim',
	full_cut: 'Full Cut',
	no_trim: 'No Trim'
}

export const GROOMING_SERVICES = {
	cleanup: 'cleanup',
	trim: 'trim',
	haircut: 'haircut'
}

export const COAT_TYPES = {
	combination: 'Combination',
	corded: 'Corded',
	curly: 'Curly',
	double: 'Double',
	drop: 'Drop',
	hairless: 'Hairless',
	heavy: 'Heavy',
	short: 'Short',
	silky: 'Silky',
	smooth: 'Smooth',
	wavy: 'Wavy',
	wire_long: 'Wire (Long)',
	wire_short: 'Wire (Short)',
	doodle_shaggy: 'Doodle (Shaggy)',
	doodle_wavy: 'Doodle (Wavy)',
	doodle_curly: 'Doodle (Curly)',
	doodle_wool: 'Doodle (Wool)'
}

export const COATS_CONFIG = {
	[COAT_TYPES.combination]: {
		id: COAT_TYPES.combination,
		label: `${COAT_TYPES.combination} Coat`,
		coat_length: COAT_LENGTH.short,
		grooming_level: GROOMING_LEVELS.trim
	},
	[COAT_TYPES.corded]: {
		id: COAT_TYPES.corded,
		label: `${COAT_TYPES.corded} Coat`,
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.curly]: {
		id: COAT_TYPES.curly,
		label: `${COAT_TYPES.curly} Coat`,
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.double]: {
		id: COAT_TYPES.double,
		label: 'Dense Coat',
		coat_length: COAT_LENGTH.medium,
		grooming_level: GROOMING_LEVELS.trim
	},
	[COAT_TYPES.drop]: {
		id: COAT_TYPES.drop,
		label: `${COAT_TYPES.drop} Coat`,
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.hairless]: {
		id: COAT_TYPES.hairless,
		label: `${COAT_TYPES.hairless} Coat`,
		coat_length: COAT_LENGTH.short,
		grooming_level: GROOMING_LEVELS.no_trim
	},
	[COAT_TYPES.heavy]: {
		id: COAT_TYPES.heavy,
		label: `${COAT_TYPES.heavy} Coat`,
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.trim
	},
	[COAT_TYPES.short]: {
		id: COAT_TYPES.short,
		label: `${COAT_TYPES.short} Coat`,
		coat_length: COAT_LENGTH.short,
		grooming_level: GROOMING_LEVELS.no_trim
	},
	[COAT_TYPES.silky]: {
		id: COAT_TYPES.silky,
		label: `${COAT_TYPES.silky} Coat`,
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.smooth]: {
		id: COAT_TYPES.smooth,
		label: `${COAT_TYPES.smooth} Coat`,
		coat_length: COAT_LENGTH.short,
		grooming_level: GROOMING_LEVELS.no_trim
	},
	[COAT_TYPES.wavy]: {
		id: COAT_TYPES.wavy,
		label: `${COAT_TYPES.wavy} Coat`,
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.wire_long]: {
		id: COAT_TYPES.wire_long,
		label: 'Long Wire Coat',
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.wire_short]: {
		id: COAT_TYPES.wire_short,
		label: 'Short Wire Coat',
		coat_length: COAT_LENGTH.medium,
		grooming_level: GROOMING_LEVELS.trim
	}
}

export const DOODLE_COATS_CONFIG = {
	[COAT_TYPES.combination]: {
		id: COAT_TYPES.combination,
		label: 'Doodle - Combo',
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.trim
	},
	[COAT_TYPES.wire_long]: {
		id: COAT_TYPES.wire_long,
		label: 'Doodle - Wire Coat (long)',
		coat_length: COAT_LENGTH.long,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.doodle_shaggy]: {
		id: COAT_TYPES.doodle_shaggy,
		label: 'Doodle - Shaggy Coat',
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.doodle_wavy]: {
		id: COAT_TYPES.doodle_wavy,
		label: 'Doodle - Wavy Coat',
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.doodle_curly]: {
		id: COAT_TYPES.doodle_curly,
		label: 'Doodle - Curly Coat',
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	},
	[COAT_TYPES.doodle_wool]: {
		id: COAT_TYPES.doodle_wool,
		label: 'Doodle - Wool Coat',
		coat_length: COAT_LENGTH.variable,
		grooming_level: GROOMING_LEVELS.full_cut
	}
}

export const DOODLE_COATS = [
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.combination].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.combination].label,
		src: DoodleCombo
	},
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.wire_long].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.wire_long].label,
		src: DoodleWire
	},
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_shaggy].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_shaggy].label,
		src: DoodleShaggy
	},
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_wavy].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_wavy].label,
		src: DoodleWavy
	},
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_curly].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_curly].label,
		src: DoodleCurly
	},
	{
		type: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_wool].id,
		label: DOODLE_COATS_CONFIG[COAT_TYPES.doodle_wool].label,
		src: DoodleWool
	}
]

export const DOG_COATS = [
	{
		type: COATS_CONFIG[COAT_TYPES.smooth].id,
		label: COATS_CONFIG[COAT_TYPES.smooth].label,
		description: `${DOG_BREEDS.french_bulldog}, ${DOG_BREEDS.pitbull_terrier}, ${DOG_BREEDS.dalmatian}, etc.`,
		src: SmoothCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.short].id,
		label: COATS_CONFIG[COAT_TYPES.short].label,
		description: `${DOG_BREEDS.labrador_retriever}, ${DOG_BREEDS.beagle}, ${DOG_BREEDS.pug}, etc.`,
		src: ShortCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.combination].id,
		label: COATS_CONFIG[COAT_TYPES.combination].label,
		description: `${DOG_BREEDS.golden_retriever}, ${DOG_BREEDS.border_collie}, etc.`,
		src: CombinationCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.double].id,
		label: COATS_CONFIG[COAT_TYPES.double].label,
		description: `${DOG_BREEDS.siberian_husky}, ${DOG_BREEDS.shiba_inu}, ${DOG_BREEDS.german_shepherd}, ${DOG_BREEDS.corgi},etc.`,
		src: DenseCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.heavy].id,
		label: COATS_CONFIG[COAT_TYPES.heavy].label,
		description: `${DOG_BREEDS.samoyed}, ${DOG_BREEDS.bernese_mountain_dog}, etc.`,
		src: HeavyCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.silky].id,
		label: COATS_CONFIG[COAT_TYPES.silky].label,
		description: `${DOG_BREEDS.irish_setter}, ${DOG_BREEDS.cocker_spaniel}, ${DOG_BREEDS.brittany}, etc.`,
		src: SilkyCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.wire_short].id,
		label: COATS_CONFIG[COAT_TYPES.wire_short].label,
		description: `${DOG_BREEDS.brussels_griffon}, ${DOG_BREEDS.border_terrier}, etc.`,
		src: ShortWireCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.wire_long].id,
		label: COATS_CONFIG[COAT_TYPES.wire_long].label,
		description: `Schnauzer, Westie, ${DOG_BREEDS.otterhound}, etc.`,
		src: LongWireCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.wavy].id,
		label: COATS_CONFIG[COAT_TYPES.wavy].label,
		description: `${DOG_BREEDS.wheaten_terrier}, ${DOG_BREEDS.shih_tzu}, ${DOG_BREEDS.maltese}, etc.`,
		src: WavyCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.curly].id,
		label: COATS_CONFIG[COAT_TYPES.curly].label,
		description: `Poodle, ${DOG_BREEDS.bichon_frise}, ${DOG_BREEDS.pumi}, etc.`,
		src: CurlyCoat
	},
	{
		type: COATS_CONFIG[COAT_TYPES.drop].id,
		label: COATS_CONFIG[COAT_TYPES.drop].label,
		description: `${DOG_BREEDS.bearded_collie}, ${DOG_BREEDS.silky_terrier}, etc.`,
		src: DropCoat
	}
]

export const NAIL_TRIMMING_OPTIONS = {
	standard: 'Trim nails',
	never: 'Do not trim nails'
}

export const GLANDS_OPTIONS = {
	none: 'Never express anal glands',
	standard: 'Express anal glands as needed',
	always: 'Always express anal glands'
}

export const EAR_CLEANING_OPTIONS = {
	none: 'Do not clear ears',
	standard: 'Standard ear cleaning',
	trim: 'Standard ear cleaning & trim hair',
	pluck: 'Standard ear cleaning & pluck hair',
	'keep-dry': 'Ear issues: no cleaning & keep dry'
}

export const GROOMING_ADDONS = {
	shed_control: 'Shed Control'
}
